module.exports = "/images/dashboard_white.svg?de79c16aeb78b5d78fd34d27cd9a9ec1";